import type { ReactNode } from 'react';
import type { ContentBlock } from '@fametrue/shared';

/**
 * Blocchi strutturati di un blocco Diagnosi (`level2.*.blocks`), nell'ordine
 * del JSON. `table`: occhiello in `<caption>`, prima colonna `th[scope=row]`,
 * colonne `numeric` con classe `num`; stili in `app.css` (`.cb-*`). `paragraph`:
 * HTML inline, già sanificato all'import.
 */
export function ContentBlocks({ blocks }: { blocks: ContentBlock[] }): ReactNode {
  return (
    <>
      {blocks.map((block, i) =>
        block.type === 'table' ? (
          <BlockTable key={i} block={block} />
        ) : (
          <p key={i} className="cb-para" dangerouslySetInnerHTML={{ __html: block.text }} />
        ),
      )}
    </>
  );
}

function BlockTable({ block }: { block: Extract<ContentBlock, { type: 'table' }> }): ReactNode {
  const numeric = block.columns.map((c) => c.numeric === true);
  const cls = (i: number): string | undefined => (numeric[i] ? 'num' : undefined);

  return (
    <div className="table-scroll">
      <table className="cb-table">
        {block.caption ? <caption className="cb-caption">{block.caption}</caption> : null}
        <thead>
          <tr>
            {block.columns.map((col, i) => (
              <th key={i} scope="col">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {block.rows.map((row, r) => (
            <tr key={r}>
              {row.map((cell, c) =>
                c === 0 ? (
                  <th key={c} scope="row" className={cls(c)}>
                    {cell}
                  </th>
                ) : (
                  <td key={c} className={cls(c)}>
                    {cell}
                  </td>
                ),
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
